import * as React from 'react';
import { SVGProps } from 'react';

const IconGeoSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 3a8 8 0 0 0-8 8v.2c0 1.186.257 2.358.755 3.435l.07.153a33.718 33.718 0 0 0 5.666 8.552L14 25l1.51-1.66a33.717 33.717 0 0 0 5.665-8.552l.07-.153A8.199 8.199 0 0 0 22 11.2V11a8 8 0 0 0-8-8Zm0 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
    />
  </svg>
);
export default IconGeoSizeL;
